import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  selectFilteredCategory,
  selectPropCategories,
  setPropCategoryFilter,
} from "../../app/slices/PropLibrarySlice";
import { PropCategoryDot } from "./PropCategoryChip";

/** Muted labels with category-coloured dots; blue indicates selection. */
export default function PropLibraryRail() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const categories = useSelector(selectPropCategories);
  const selectedCategory = useSelector(selectFilteredCategory);

  const entry = (options: {
    key: string;
    label: string;
    isSelected: boolean;
    hexColor?: string;
    onClick: () => void;
  }) => {
    return (
      <button
        key={options.key}
        type="button"
        role="tab"
        aria-selected={options.isSelected}
        onClick={options.onClick}
        className={classNames(
          "flex items-center gap-[8px] text-left px-[10px] py-[7px] rounded-[6px] text-[13px] border transition-colors",
          options.isSelected
            ? "border-creator-primary bg-creator-primary-washed text-creator-text font-medium"
            : "border-transparent text-creator-text-sub hover:bg-creator-childActive"
        )}
      >
        <PropCategoryDot hexColor={options.hexColor} large />
        <span className="truncate">
          {options.label.charAt(0).toUpperCase() + options.label.slice(1)}
        </span>
      </button>
    );
  };

  return (
    <div
      role="tablist"
      aria-orientation="vertical"
      aria-label={t("prop_library_ui.categories_label") ?? ""}
      className="w-[168px] shrink-0 border-r border-creator-border bg-creator-primary-background p-[8px] flex flex-col gap-[6px] overflow-y-auto pit-quiet-scrollbar"
    >
      <div className="px-[10px] pt-[6px] pb-[4px] text-[10px] font-semibold uppercase tracking-[0.08em] text-creator-text-sub">
        {t("prop_library_ui.categories_label")}
      </div>
      {entry({
        key: "all",
        label: t("prop_library_ui.all"),
        isSelected: selectedCategory === "",
        onClick: () => dispatch(setPropCategoryFilter("")),
      })}
      {categories.map((category) =>
        entry({
          key: category.id,
          label: category.name,
          isSelected: category.name === selectedCategory,
          hexColor: category.hexColor,
          onClick: () => dispatch(setPropCategoryFilter(category.name)),
        })
      )}
    </div>
  );
}
